// extracted by mini-css-extract-plugin
export default {"container":"sel_1tdQu","withBorder":"sel_wit_13nor"};